import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type DebriefStage } from '@momentum/types';
import { useDebriefFactsState } from '../../shared/context/DebriefFactsStateContext';
import { FactDialog } from './FactDialog';

interface AddFactSectionProps {
  stage: DebriefStage;
  variant: 'inline' | 'empty-state';
}

export function AddFactSection({ stage, variant }: AddFactSectionProps) {
  const { t } = useTranslation('debriefV2');
  const { addFact } = useDebriefFactsState();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      {variant === 'empty-state' ? (
        <button
          type="button"
          onClick={() => setIsDialogOpen(true)}
          className="mt-3 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
        >
          {t('gather.emptyStage.addFactManually')}
        </button>
      ) : (
        <button
          type="button"
          onClick={() => setIsDialogOpen(true)}
          className="mt-2 inline-flex items-center text-xs font-medium text-slate-500 hover:text-slate-800 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-md px-1.5 py-1 -ms-1.5"
        >
          {t('gather.addFact')}
        </button>
      )}

      <FactDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        mode="add"
        stage={stage}
        showDateField
        onSave={(draft) => addFact(stage, draft)}
      />
    </>
  );
}
